<template>
  <core-input
    v-bind="$attrs"
    v-on="$listeners"
    @change="val => $emit('change', val)"
    inputType="textarea"
  />
</template>

<script>
export default {
  inheritAttrs: false
};
</script>
